import { useState } from 'react';

const faqs = [
  {
    q: '爱看影院需要注册或付费吗？',
    a: '完全不需要！爱看影院所有免费电影和免费电视剧全集均可直接在线观看，无需注册账号，也没有任何隐藏收费。我们坚持以完全免费的方式为影迷提供高清影视资源。',
  },
  {
    q: '视频播放卡顿或加载慢怎么办？',
    a: '爱看影院采用智能CDN加速和多线路切换技术，确保流畅播放。如遇卡顿，建议尝试切换播放线路（播放器内可选），或检查您的网络环境。我们持续优化播放体验，绝大多数用户反馈播放流畅不缓冲。',
  },
  {
    q: '支持哪些设备观看？',
    a: '爱看影院全面适配PC电脑、平板、手机等各种设备，无需下载任何APP或插件。在任何支持HTML5浏览器的设备上打开网站即可享受高清观影体验，真正做到随时随地免费在线观看。',
  },
  {
    q: '影视资源多久更新一次？',
    a: '我们拥有专业的资源更新团队，每日定时更新热播电影、电视剧、综艺和动漫。热播剧集一般在播出后数小时内即可在爱看影院观看，确保您不错过任何精彩内容。',
  },
  {
    q: '如何找到我想看的影片？',
    a: '您可以通过首页的搜索功能、分类索引浏览不同类型影片，或查看精选推荐和热播榜单。我们也提供热门话题标签帮助您发现当下最受欢迎的影视内容。如果找不到想要的资源，欢迎通过联系我们页面提交需求。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-900">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 font-bold mb-3">
              常见问题
            </h2>
            <p className="text-sm text-foreground-400 max-w-lg mx-auto">
              关于爱看影院的常见疑问，这里都有解答
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, idx) => (
              <div
                key={idx}
                className="bg-background-800/50 border border-background-700/30 rounded-xl overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                  className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer hover:bg-background-800/70 transition-colors"
                >
                  <h3 className="text-sm text-foreground-100 font-medium pr-4">{faq.q}</h3>
                  <i
                    className={`flex-shrink-0 text-foreground-400 transition-transform duration-200 ${
                      openIndex === idx ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </button>
                {openIndex === idx && (
                  <div className="px-6 pb-4">
                    <p className="text-sm text-foreground-400 leading-relaxed">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}